import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import IntegrationsAPIClient from "../../api/integrationsAPIs";
import ProgressSpinner from ".././Common/ProgressSpinner";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";

const CalendarCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  const [googleQueryString, setGoogleQueryString] = useState<string>("");
  const [authoriseCallback, setAuthoriseCallback] = useState(false);
  const { showSnackbar } = useDisplaySnackbar();

  const { isLoading, isFetching, isSuccess, isError, error, data } =
    IntegrationsAPIClient.useAuthoriseCallback(
      googleQueryString,
      authoriseCallback
    );

  useEffect(() => {
    const queryParamString = queryString.parse(location.search);
    const updatedQueryParamString = {
      ...queryParamString,
      code: queryParamString["callbackCode"],
      callbackCode: undefined,
    };
    setGoogleQueryString(queryString.stringify(updatedQueryParamString));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (googleQueryString) setAuthoriseCallback(true);
  }, [googleQueryString]);

  useEffect(() => {
    if (isLoading || isFetching) {
      setShowSpinner(true);
    }
    if (!isLoading && !isFetching) {
      setShowSpinner(false);
    }
    if (isSuccess) {
      if (data?.data?.data) navigate("/settings");
    }
    if (isError) {
      showSnackbar("error", error);
    }
  }, [isLoading, isFetching, isSuccess, isError, data]);

  return <ProgressSpinner showSpinner={showSpinner} />;
};

export default CalendarCallback;
